import { normalizeParams } from '../_center-adaptor/normalizeParams';
export default {
    resultListingType: state => {
        let listingType = '';
        let listingSource = (state.listingSource || '')
            .toLowerCase()
            .replace(/^\d\+/, '')
            .replace(/\+/g, ' ');
        if (listingSource === 'sold listings') {
            listingType = 'sold-listing';
        } else if (listingSource === 'all listings' || !state.listingSource) {
            listingType = undefined;
        } else if (listingSource === 'single property promotion') {
            listingType = 'single-property-promotion';
        } else {
            listingType = 'featured-listing';
        }
        return listingType;
    },
    noMapSearch: state => {
        const { mapCondition, keywords } = state;
        const { mapPath, mapSearch } = mapCondition;
        return !mapPath && !mapSearch && keywords && keywords.length === 0;
    },
    listingMarkers: state => {
        let selectedHouse = state.selectedHouse;
        let markers = state.result.listings.filter(
            house => selectedHouse[house.id]
        );
        return markers;
    },
    locationCondition(state, getters, rootState) {
        const { mapCondition, keywords } = state;
        const isSearchCenter = rootState.common.isSearchCenter;
        let params = {};
        if (mapCondition.mapSearch) {
            if (!mapCondition.rect) {
                console.warn('mapCondition.rect is empty', mapCondition);
                return params;
            }
            const posArr = mapCondition.rect.split(',');
            let mapPathArr = [
                { lat: posArr[0], lng: posArr[1] },
                { lat: posArr[0], lng: posArr[3] },
                { lat: posArr[2], lng: posArr[3] },
                { lat: posArr[2], lng: posArr[1] }
            ];
            const mapPath = JSON.stringify(mapPathArr);
            if (isSearchCenter) {
                mapPathArr = mapPathArr.map(o => JSON.stringify(o));
                (params.condition = {}) && (params.condition.location = {});
                params.condition.location.mapPath = mapPathArr;
                params.condition = JSON.stringify(params.condition);
            } else {
                params.mapPath = mapPath;
            }
        } else if (mapCondition.mapPath) {
            if (isSearchCenter) {
                (params.condition = {}) && (params.condition.location = {});
                params.condition.location.mapPath = mapCondition.mapPath;
                params.condition = JSON.stringify(params.condition);
            } else {
                params.mapPath = mapCondition.mapPath;
            }
        } else if (mapCondition.mapRadius) {
            if (isSearchCenter) {
                (params.condition = {}) && (params.condition.location = {});
                params.condition.location.mapRadius = mapCondition.mapRadius;
                params.condition = JSON.stringify(params.condition);
            } else {
                params.mapRadius = mapCondition.mapRadius;
            }
        } else if (Array.isArray(keywords) && keywords.length > 0) {
            const key = keywords.map(item => item.keyword).join(';');
            const keywordType = keywords
                .map(item => item.keywordType)
                .join(';');
            params = normalizeParams(
                isSearchCenter,
                {
                    key,
                    keywordType
                },
                {},
                { needKey: true }
            );
        }
        return params;
    }
};
